import React from 'react';
import PropTypes from 'prop-types';
import { formatPrice } from 'Utils';
import Button from 'Components/Button';
import Accordion from 'Components/Accordion';
import Price from 'Components/Price';
import { Container, Row, Col } from 'Components/Grid';
import styles from './styles.scss';
import ConsumptionData from 'Components/ConsumptionData';
import Typography from 'Components/Typography';
import cn from 'classnames';

const ServiceBox = ({
  headline,
  description,
  scopes,
  benefits,
  price,
  priceText,
  priceType,
  onContactClick,
  footnote,
  consumptionText,
  buttonLabel,
  trackingLabel,
}) => (
  <div className={styles.root}>
    <Container>
      <Typography.Headline
        className={styles.headline}
        forceUppercase={true}
        level="h2"
        levelVisually="h3"
        value={headline}
      />
      <div className={styles.description} dangerouslySetInnerHTML={{ __html: description }} />

      <Row className={styles.accordions}>
        <Col cols={12} m={6}>
          {scopes.length > 0 && (
            <Accordion
              label=""
              headline={{
                ariaLabel: `Leistungsumfang für ${headline}`,
                value: (
                  <>
                    Leistungsumfang<span className="sr-only"> für {headline}</span>
                  </>
                ),
              }}
              hasHierarchy={true}
              collapsible="m"
            >
              <ul className={styles.list}>
                {scopes.map((scope) => {
                  return <li key={`scope-${scope.id}}`}>{scope.name}</li>;
                })}
              </ul>
            </Accordion>
          )}
        </Col>
        <Col cols={12} m={6}>
          {benefits.length > 0 && (
            <Accordion
              label=""
              headline={{
                ariaLabel: `Vorteile für ${headline}`,
                value: (
                  <>
                    Vorteile<span className="sr-only"> für {headline}</span>
                  </>
                ),
              }}
              hasHierarchy={true}
              collapsible="m"
            >
              <ul className={styles.list}>
                {benefits.map((benefit) => {
                  return <li key={`benefit-${benefit.id}}`}>{benefit.name}</li>;
                })}
              </ul>
            </Accordion>
          )}
        </Col>
      </Row>
      <div className={styles.footer}>
        {priceType !== 'NONE' && (
          <div className={styles.price}>
            <Price value={formatPrice(price)} prefix={priceType} />
            {(priceText || footnote) && (
              <Typography.Text
                levelVisually="h5"
                forceUppercase={true}
                tag="span"
                value={
                  <>
                    {priceText}
                    {footnote && (
                      <sup>
                        <span className="sr-only">Fußnote </span>
                        {footnote.number}
                      </sup>
                    )}
                  </>
                }
              />
            )}
          </div>
        )}
        <div
          className={cn({
            [styles.cta]: true,
            [styles.ctaLeft]: priceType !== 'NONE',
          })}
        >
          <Button
            variant="secondary"
            label={buttonLabel}
            ariaLabel={`${buttonLabel} - öffnet Modal für ${headline}`}
            onClick={onContactClick}
            trackingLabel={trackingLabel}
          />
        </div>
      </div>
    </Container>

    <ConsumptionData consumptionText={[consumptionText]} style={{ marginTop: '30px' }} />
  </div>
);

ServiceBox.propTypes = {
  headline: PropTypes.string,
  description: PropTypes.string,
  scopes: PropTypes.array,
  benefits: PropTypes.array,
  price: PropTypes.number,
  priceText: PropTypes.string,
  priceType: PropTypes.string,
  onContactClick: PropTypes.func,
  footnote: PropTypes.object,
  consumptionText: PropTypes.string,
  buttonLabel: PropTypes.string,
  trackingLabel: PropTypes.string,
};

export default ServiceBox;
